import { Component, OnInit, OnDestroy } from '@angular/core';
import { CalendarNotificationService } from '../../services/service.index';
import { CNNotification } from '../../models/cnnotification.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-notificationcalendar',
  templateUrl: './notificationcalendar.component.html',
  styleUrls: [],
})
export class NotificationCalendarComponent implements OnInit, OnDestroy {
  loading = true;

  notifications: Array<CNNotification> = [];

  notification1 = new CNNotification('', '', '', '');
  notification2 = new CNNotification('', '', '', '');
  notification3 = new CNNotification('', '', '', '');
  notification4 = new CNNotification('', '', '', '');
  private unsubscribe$ = new Subject<void>();

  constructor(
    private calendarNotificationService: CalendarNotificationService
  ) { }

  ngOnInit(): void {
    this.getNotifications();
    // this.getNotificationTimeFromDay();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getNotifications() {
    this.calendarNotificationService.getCalendar().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.notification1 = new CNNotification(
        'Notification1',
        res.docs[0].data().Notification1.title
          ? res.docs[0].data().Notification1.title
          : '',
        res.docs[0].data().Notification1.description
          ? res.docs[0].data().Notification1.description
          : '',
        res.docs[0].data().Notification1.onlyActive
          ? res.docs[0].data().Notification1.onlyActive
          : false
      );
      this.notification2 = new CNNotification(
        'Notification2',
        res.docs[0].data().Notification2.title
          ? res.docs[0].data().Notification2.title
          : '',
        res.docs[0].data().Notification2.description
          ? res.docs[0].data().Notification2.description
          : '',
        res.docs[0].data().Notification2.onlyActive
          ? res.docs[0].data().Notification2.onlyActive
          : false
      );
      this.notification3 = new CNNotification(
        'Notification3',
        res.docs[0].data().Notification3.title
          ? res.docs[0].data().Notification3.title
          : '',
        res.docs[0].data().Notification3.description
          ? res.docs[0].data().Notification3.description
          : '',
        res.docs[0].data().Notification3.onlyActive
          ? res.docs[0].data().Notification3.onlyActive
          : false
      );
      this.notification4 = new CNNotification(
        'Notification4',
        res.docs[0].data().Notification4.title
          ? res.docs[0].data().Notification4.title
          : '',
        res.docs[0].data().Notification4.description
          ? res.docs[0].data().Notification4.description
          : '',
        res.docs[0].data().Notification4.onlyActive
          ? res.docs[0].data().Notification4.onlyActive
          : false
      );

      res.docs.forEach((doc) => {
        this.getHourPerDay(doc);
      });

      this.loading = false;
    });
  }

  getHourPerDay(doc: any) {
    switch (doc.id) {
      case '0':
        this.notification1.sundayTime = doc.data().Notification1.time;
        this.notification1.sunday = doc.data().Notification1.enabled;
        this.notification2.sundayTime = doc.data().Notification2.time;
        this.notification2.sunday = doc.data().Notification2.enabled;
        this.notification3.sundayTime = doc.data().Notification3.time;
        this.notification3.sunday = doc.data().Notification3.enabled;
        this.notification4.sundayTime = doc.data().Notification4.time;
        this.notification4.sunday = doc.data().Notification4.enabled;
        break;
      case '1':
        this.notification1.mondayTime = doc.data().Notification1.time;
        this.notification1.monday = doc.data().Notification1.enabled;
        this.notification2.mondayTime = doc.data().Notification2.time;
        this.notification2.monday = doc.data().Notification2.enabled;
        this.notification3.mondayTime = doc.data().Notification3.time;
        this.notification3.monday = doc.data().Notification3.enabled;
        this.notification4.mondayTime = doc.data().Notification4.time;
        this.notification4.monday = doc.data().Notification4.enabled;
        break;
      case '2':
        this.notification1.tuesdayTime = doc.data().Notification1.time;
        this.notification1.tuesday = doc.data().Notification1.enabled;
        this.notification2.tuesdayTime = doc.data().Notification2.time;
        this.notification2.tuesday = doc.data().Notification2.enabled;
        this.notification3.tuesdayTime = doc.data().Notification3.time;
        this.notification3.tuesday = doc.data().Notification3.enabled;
        this.notification4.tuesdayTime = doc.data().Notification4.time;
        this.notification4.tuesday = doc.data().Notification4.enabled;
        break;
      case '3':
        this.notification1.wednesdayTime = doc.data().Notification1.time;
        this.notification1.wednesday = doc.data().Notification1.enabled;
        this.notification2.wednesdayTime = doc.data().Notification2.time;
        this.notification2.wednesday = doc.data().Notification2.enabled;
        this.notification3.wednesdayTime = doc.data().Notification3.time;
        this.notification3.wednesday = doc.data().Notification3.enabled;
        this.notification4.wednesdayTime = doc.data().Notification4.time;
        this.notification4.wednesday = doc.data().Notification4.enabled;
        break;
      case '4':
        this.notification1.thursdayTime = doc.data().Notification1.time;
        this.notification1.thursday = doc.data().Notification1.enabled;
        this.notification2.thursdayTime = doc.data().Notification2.time;
        this.notification2.thursday = doc.data().Notification2.enabled;
        this.notification3.thursdayTime = doc.data().Notification3.time;
        this.notification3.thursday = doc.data().Notification3.enabled;
        this.notification4.thursdayTime = doc.data().Notification4.time;
        this.notification4.thursday = doc.data().Notification4.enabled;
        break;
      case '5':
        this.notification1.fridayTime = doc.data().Notification1.time;
        this.notification1.friday = doc.data().Notification1.enabled;
        this.notification2.fridayTime = doc.data().Notification2.time;
        this.notification2.friday = doc.data().Notification2.enabled;
        this.notification3.fridayTime = doc.data().Notification3.time;
        this.notification3.friday = doc.data().Notification3.enabled;
        this.notification4.fridayTime = doc.data().Notification4.time;
        this.notification4.friday = doc.data().Notification4.enabled;
        break;
      case '6':
        this.notification1.saturdayTime = doc.data().Notification1.time;
        this.notification1.saturday = doc.data().Notification1.enabled;
        this.notification2.saturdayTime = doc.data().Notification2.time;
        this.notification2.saturday = doc.data().Notification2.enabled;
        this.notification3.saturdayTime = doc.data().Notification3.time;
        this.notification3.saturday = doc.data().Notification3.enabled;
        this.notification4.saturdayTime = doc.data().Notification4.time;
        this.notification4.saturday = doc.data().Notification4.enabled;
        break;
      default:
        break;
    }
  }
}
